import React, {useRef,useEffect} from "react";
import TinySlider from "tiny-slider-react";
import styles from "./CreatorSlider.module.scss";
import {designs} from "../CustomWraps.data";
import {useDispatch, useSelector} from "react-redux";
import ImageWrapper from "components/imageWrapper/ImageWrapper";
import {buttonClick} from "utils/Helpers";

const CreatorSlider = (props) => {

    const wrapSelection = useSelector(state => state.wrapSelection);
    const windowData = useSelector(state => state.window);
    const accessible = useSelector(state => state.accessible);
    const dispatch = useDispatch()
    const contentBoxes = useRef([]);
    const boxHeight = useRef(0);
    const tinySlider = useRef();
    const next = useRef();
    const prev = useRef();

    const tinyCarouselSettings = {
        lazyload: true,
        mouseDrag: true,
        controls: false,
        loop: false,
        startIndex: 0
    }

    useEffect(()=>{

        setTimeout(()=>{

            if(contentBoxes.current){

                if(windowData.width > 1024){

                    contentBoxes.current.forEach((box)=>{

                        if(box){
                            let style = window.getComputedStyle(box, null);
                            let newBoxHeight = parseInt(style.getPropertyValue("height"));

                            if(boxHeight.current < newBoxHeight){
                                boxHeight.current = newBoxHeight
                            }
                        }
                    })

                    contentBoxes.current.forEach((box)=>{
                        if(box) box.style.height = boxHeight.current + 'px';
                    });

                } else {
                    contentBoxes.current.forEach((box)=>{
                        if(box) box.style.height = '';
                    });
                }

            }

        }, 300)

    }, [windowData])

    useEffect(()=>{

        setTimeout(()=>{

            if(prev.current) prev.current.disabled = true;

            if(tinySlider.current) tinySlider.current.slider.events.on('indexChanged', ()=>{
                let sliderInfo = tinySlider.current.slider.getInfo();
                next.current.disabled = sliderInfo.slideCount === (sliderInfo.items + sliderInfo.index);
                prev.current.disabled = sliderInfo.index === 0;
            })

        }, 100)

    }, [])



    function selectDesign(design) {

        dispatch({ type: "SET_WRAP_SELECTION",
            payload: {
                ...wrapSelection,
                design: design
            }
        });

    }

    function buildSlider(){

        let slides = [];

        designs.forEach((design, i) => {

            if(design && design.ownerImages){
                slides.push(
                    <div key={i} className={styles.slide}>
                        <div ref={(el)=>contentBoxes.current.push(el)} className={styles.blackBox}>
                            <div className={styles.product}>
                                <img src={design.productImage} alt={design.name}/>
                            </div>
                            <div className={styles.info}>
                                <h5>{design.owner}</h5>
                                <p dangerouslySetInnerHTML={{__html:design.statement}}/>
                                <div aria-label={`Select design by ${design.owner}`} tabIndex={!accessible.modalOpen ? 0 : null} role={!accessible.modalOpen ? 'button' : null} onKeyDown={buttonClick} className={styles.button} onClick={()=>selectDesign(design)}>Try it on</div>
                            </div>
                        </div>
                        <ImageWrapper className={styles.bgImage} set={design.ownerImages} alt={design.name} scaleDown={true}/>
                    </div>
                )
            }

        })

        return slides;

    }

    function ariaHidden (){
        return (wrapSelection.product && !wrapSelection.design) || (!wrapSelection.product && wrapSelection.design)
    }


    return (
        <div aria-hidden={ariaHidden()} className={styles.creatorSlider}>

            <div className={styles.controls}>
                <button disabled={accessible.modalOpen} aria-label={'Previous Slide'} ref={prev} className={`${styles.prev}`} onClick={()=>tinySlider.current.slider.goTo('prev')}>
                    <img src={'https://msobd-storage.azureedge.net/images/customWraps/arrow.png'} alt={'Previous Creator'}/>
                </button>

            </div>

            <TinySlider settings={tinyCarouselSettings} ref={tinySlider}
            >
                {buildSlider()}
            </TinySlider>

            <div className={styles.controls}>
                <button disabled={accessible.modalOpen} aria-label={'Next Slide'} ref={next} className={`${styles.next}`} onClick={()=>tinySlider.current.slider.goTo('next')}>
                    <img src={'https://msobd-storage.azureedge.net/images/customWraps/arrow.png'} alt={'Next Creator'}/>
                </button>
            </div>

        </div>
    );
}

export default CreatorSlider;